export const alertProtocolAction = {
  setSelectedContent: (state, action) => {
    state.selectedContent = action.payload;
  },
  setIsEditModalOpen: (state, action) => {
    state.isEditModalOpen = action.payload;
  },
  setIsEditMode: (state, action) => {
    state.isEditMode = action.payload;
  },
  setIsCopyMode: (state, action) => {
    state.isCopyMode = action.payload;
  },
  clearSelectedContent: (state) => {
    state.selectedContent = null;
    state.isEditModalOpen = false;
    state.isEditMode = false;
    state.isCopyMode = false;
  },
  setFilterAccount: (state, action) => {
    state.filterAccount = action.payload;
  },
  setFilterDeviceType: (state, action) => {
    state.filterDeviceType = action.payload;
  },
  setAlertProtocols: (state, action) => {
    state.alertProtocols = action.payload;
  },
};
